import { useDeviceType } from '@picsart/design-system/hooks/device';

import createRemoteSettingHook from '@/utils/user/createRemoteSettingHook';

interface MobilePresetFeedSetting {
  enabled: boolean;
}

const REMOTE_SETTING_NAME = 'genai_studio_mobile_preset_feed';

const DEFAULT_SETTING: MobilePresetFeedSetting = {
  enabled: true,
};

const isMobilePresetFeedSetting = (
  settings: unknown
): settings is MobilePresetFeedSetting =>
  typeof settings === 'object' &&
  settings !== null &&
  typeof (settings as MobilePresetFeedSetting).enabled === 'boolean';

const { useSetting, getSetting } = createRemoteSettingHook({
  name: REMOTE_SETTING_NAME,
  defaultValue: DEFAULT_SETTING,
  validate: isMobilePresetFeedSetting,
  select: (settings) => settings.enabled,
});

/**
 * Resolves the experiment setting for callers outside React (the preset
 * deeplink handler). Shares the module cache with the hook and dedupes
 * concurrent fetches.
 */
export const getMobilePresetFeedSetting = getSetting;

/**
 * The experiment gate: viewport-mobile AND the remote setting. Fetched once per
 * session, shared with `getMobilePresetFeedSetting`.
 */
const useMobilePresetFeed = (): { isPresetFeedActive: boolean } => {
  const { isMobile } = useDeviceType();
  const isEnabled = useSetting();

  return { isPresetFeedActive: isMobile && isEnabled };
};

export default useMobilePresetFeed;
